<script setup lang="ts">
import { RouterLink } from 'vue-router';

// Footer link columns (Figma node 1:1297). Labels map onto existing routes
// where they exist; everything else points at the /coming-soon placeholder.
const columns = [
  {
    heading: 'MARKETPLACE',
    links: [
      { label: 'Browse Skins', to: '/catalog' },
      { label: 'Knives', to: { path: '/catalog', query: { cat: 'knives' } } },
      { label: 'Gloves', to: { path: '/catalog', query: { cat: 'gloves' } } },
      { label: 'Stickers', to: '/coming-soon' },
      { label: 'Cases', to: '/coming-soon' },
    ],
  },
  {
    heading: 'COMPANY',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Blog', to: '/blog' },
      { label: 'Careers', to: '/coming-soon' },
      { label: 'Press', to: '/coming-soon' },
    ],
  },
  {
    heading: 'SUPPORT',
    links: [
      { label: 'Help Center', to: '/faq' },
      { label: 'Trading Guide', to: '/coming-soon' },
      { label: 'Fees', to: '/coming-soon' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    heading: 'LEGAL',
    links: [
      { label: 'Terms of Service', to: '/terms' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Cookies', to: '/cookies' },
    ],
  },
];

const socials = [
  { label: 'X (Twitter)', text: 'X' },
  { label: 'Discord', text: 'D' },
  { label: 'Steam Group', text: 'S' },
  { label: 'YouTube', text: 'Y' },
];
</script>

<template>
  <footer class="bg-[#0e0805] border-t border-[rgba(65,49,43,0.5)]" data-section="footer">
    <!-- Top section -->
    <div class="px-6 lg:px-20 pt-16 pb-12">
      <div class="flex flex-wrap lg:flex-nowrap lg:justify-between gap-12 lg:gap-16">
        <!-- Brand column -->
        <div class="w-full lg:w-[280px] flex flex-col gap-5">
          <img src="/figma/brand/juicyskins-logo.png" alt="JuicySkins" class="h-40 w-auto select-none -ml-1" />
          <p class="font-[var(--font-inter)] text-[14px] leading-[21px] text-[#e2bfb2] m-0">
            The trusted marketplace for Counter-Strike 2 skins. Buy, sell, and trade with confidence.
          </p>
          <div class="flex items-center gap-3">
            <a
              v-for="s in socials"
              :key="s.text"
              href="#"
              :aria-label="s.label"
              class="size-9 rounded-full bg-[#1d100b] border border-[rgba(107,90,80,0.4)] flex items-center justify-center font-[var(--font-display)] font-bold text-[14px] text-[#e2bfb2] no-underline hover:border-[var(--color-accent)] hover:text-[var(--color-accent)] transition-colors"
            >
              {{ s.text }}
            </a>
          </div>
        </div>

        <!-- Link columns -->
        <div v-for="col in columns" :key="col.heading" class="flex flex-col gap-5">
          <h4 class="font-[var(--font-display)] font-bold text-[12px] leading-[12px] tracking-[1.2px] text-[#f7ddd3] m-0">
            {{ col.heading }}
          </h4>
          <ul class="flex flex-col gap-3 list-none p-0 m-0">
            <li v-for="link in col.links" :key="link.label">
              <RouterLink
                :to="link.to"
                class="font-[var(--font-inter)] text-[14px] leading-[21px] text-[#e2bfb2] no-underline whitespace-nowrap hover:text-[#f7ddd3] transition-colors"
              >
                {{ link.label }}
              </RouterLink>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Bottom bar -->
    <div class="border-t border-[rgba(65,49,43,0.4)] px-6 lg:px-20 py-6 flex flex-col md:flex-row md:items-center gap-4 justify-between">
      <p class="font-[var(--font-inter)] text-[12px] leading-[18px] text-[#6b5a50] m-0">
        © 2026 JuicySkins. Not affiliated with Valve Corp. All trademarks belong to their respective owners.
      </p>
      <div class="flex items-center gap-5">
        <button
          type="button"
          class="px-3 py-[6px] rounded-full bg-[#1d100b] border border-[rgba(107,90,80,0.3)] font-[var(--font-display)] font-medium text-[12px] leading-[18px] text-[#e2bfb2] hover:border-[var(--color-accent)] transition-colors cursor-pointer"
        >
          EN ▾
        </button>
        <div class="flex items-center gap-2">
          <span
            v-for="mark in ['VISA', 'MC', 'STEAM']"
            :key="mark"
            class="px-2 py-1 rounded bg-[#1d100b] border border-[rgba(107,90,80,0.3)] font-[var(--font-display)] font-bold text-[10px] leading-none tracking-[0.5px] text-[#e2bfb2]"
          >
            {{ mark }}
          </span>
        </div>
      </div>
    </div>
  </footer>
</template>
